/// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/component.ts" />
/// <reference path="../../../../node_modules/foundation-sites/dist/js/foundation.d.ts" />
/// <reference path="../../../../node_modules/foundation-sites/js/foundation.core.js" />

declare var irep: IREP.IREP; // same vein as the scope comment below, is this global scope? 
declare var rotator: IREP.PageRotator;

namespace IREP {
    "use strict";
    export interface IPageRotatorOptions {
        timeout?: number;
    }

    var defaultOptions: IPageRotatorOptions = {
        timeout: 8000
    }
    
    export class PageRotator extends Component {

        private rotatorIsRotating: boolean = true; 
        private rotatorTimeoutId: number = 0;
        private rotatorCurrentSlide: number = 0; // need something to hold the slide num so i can restart the rotation on mouseleave

        private $pageRotator: JQuery;
        private $pageRotatorWrapper: JQuery;
        private $pageRotatorContents: JQuery;
        private $pageMediaQuery: FoundationSites.MediaQuery;

        private $focusedContent: JQuery;

        private rotatorHeight: number;
        
        private itemCount = 0;

        private options: IPageRotatorOptions;

        constructor(id: string, config: IPageRotatorOptions) {
            super(id);

            this.options = $.extend({}, defaultOptions, config);

            this.rotatorIsRotating = true;

            this.$pageRotator = $(id);
            this.$pageRotatorWrapper = this.$component.find('.page-rotator-wrapper');
            this.$pageRotatorContents = this.$component.find('.page-rotator-contents');

            this.$pageMediaQuery = Foundation.MediaQuery;
            
            this.rotatorHeight = this.$component.height();

            // refactor at some point, can just use the count if we're not doing anything with the content cells right now
            this.$pageRotatorContents.find('.page-rotator-content').each((i, e) => {
                this.itemCount++;
            });
            
            // show the first slide on construction
            this.showContent(0);

            // on breakpoint events, reinit
            let that = this; 
            $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
                that.swapBackgroundImage();
            });

            // setup mouseenter/leave events
            this.$pageRotator.on("mouseenter", function () {
                that.rotatorIsRotating = false;

                 // clear timeout
                clearTimeout(that.rotatorTimeoutId);
            });
            this.$pageRotator.on("mouseleave", function () {
                that.rotatorIsRotating = true;

                // reset/restart the timeout
                // without making an extension on setTimeout, there's no way to get the time remaining before it was cleared, so just restart
                that.rotatorTimeoutId = setTimeout(() => {
                    that.showContent((that.rotatorCurrentSlide + 1) % that.itemCount);
                }, that.options.timeout);
            });

            // setup nav click events
            this.$pageRotator.find('[id^=rotator-link-]').each((i, e) => {
                $(e).click(() => {
                    that.showContent(i);
                });
            });
        }

        private swapBackgroundImage(): void {
            let picturenode: JQuery = this.$focusedContent.find("img.hide");

            let styles = "";

            if (picturenode && this.$pageRotator) {
                // swap bg color
                var bgcolor = picturenode.css("backgroundColor");
                if (bgcolor) {
                    styles += "background-color: " + bgcolor + "; ";
                }
                else {
                    // else default bg color by removing the bg color style (parent default bg color set via the .page-rotator class)
                    styles += "background-color: none; ";
                }

                // swap bg image
                var bgimg = picturenode.prop("src");
                if (bgimg) {
                    styles += "background-image: url('" + bgimg + "'); ";
                }
                else {
                    // else what should we do? show some sort of default image? 
                }
            }
            else {
                // else what should we do? show some sort of default image? 
            }
            this.$pageRotator.attr("style", styles);
        }

        public showContent(slidenum: number): JQueryPromise<any> {

            this.rotatorCurrentSlide = slidenum;

            this.$focusedContent = this.$component.find("[id=rotator-content-" + slidenum + "]");

            // clear the timeout in case they actively clicked a slide link
            clearTimeout(this.rotatorTimeoutId);

            // modulo the slide number using the item count
            slidenum = slidenum % this.itemCount;
            
            // return a promise that will fade out and in the appropriate slides
            return this.$component.find("[id^=rotator-content-]").fadeOut({ queue: false }).promise().then((element) => {
                // removing picture element in favor of the interchange plugin that seems to be simpler for our use case
                // find the interchange img element inside this focused content container and swap the parent (wrapper) bg img for it
                this.swapBackgroundImage();
                // else leave the default background image

                // now show the content
                this.$focusedContent.fadeIn({ queue: false });
                
                // remove the selected class from all nav links
                this.$component.find("[id^=rotator-link]").removeClass("selected");

                // find the correct nav link and add the selected class
                let selectedlink: JQuery = this.$component.find("[id^=rotator-link-" + slidenum + "]");
                selectedlink.addClass("selected");

                // if we're auto rotating, then setup a timeout to call itself
                if (this.rotatorIsRotating) {
                    this.rotatorTimeoutId = setTimeout(() => {
                        this.showContent((slidenum + 1) % this.itemCount);
                    }, this.options.timeout);
                }
            });
        }
    }
}